import { Component, Input, OnInit } from '@angular/core';

import { IconLibrary } from '@finnairoyj/fcom-ui-styles/enums';
import { Observable, startWith } from 'rxjs';

import { CmsArticle, CmsContent, CmsContentType, CmsTarget } from '@fcom/core-api';
import { finShare, safeMap } from '@fcom/rx';
import { FragmentService } from '@fcom/common';

import { Item } from '../tier-benefits/tier-benefits.component';

@Component({
  selector: 'fin-promotion-segment',
  templateUrl: './promotion-segment.component.html',
  styleUrls: ['./promotion-segment.component.scss'],
})
export class PromotionSegmentComponent implements OnInit {
  @Input()
  fragmentUrl: string;

  @Input()
  fragmentParams: { [key: string]: string };

  @Input()
  invertedColors = false;

  articles$: Observable<Item[]>;
  sidebar$: Observable<CmsContent>;
  cta$: Observable<CmsTarget[]>;

  constructor(private fragmentService: FragmentService) {}

  ngOnInit(): void {
    const content$ = this.fragmentService.getFragment(this.fragmentUrl, this.fragmentParams).pipe(
      safeMap(({ contentType, items }) => (contentType === CmsContentType.CMPersonalized ? items[0]?.items : items)),
      finShare()
    );

    this.sidebar$ = content$.pipe(safeMap((articles) => articles[0]));
    this.articles$ = content$.pipe(
      safeMap((articles) =>
        articles[1].items.map((item: CmsArticle): Item => {
          let iconCategory: IconLibrary;
          switch (item.localSettings?.iconCategory) {
            case 'custom':
              iconCategory = IconLibrary.CUSTOM;
              break;
            case 'payments':
              iconCategory = IconLibrary.PAYMENTS;
              break;
            case 'tails':
              iconCategory = IconLibrary.TAILS;
              break;
            case 'svg-library':
            default:
              iconCategory = IconLibrary.SVG_LIBRARY;
              break;
          }
          return {
            article: item as CmsArticle,
            icon: {
              category: iconCategory,
              name: item.localSettings?.iconName,
            },
          };
        })
      )
    );
    this.cta$ = content$.pipe(
      safeMap((articles) => articles[2]),
      safeMap(({ target, teaserTitle }) => [{ ...target, title: teaserTitle }]),
      startWith([])
    );
  }
}
